export default class VideoPlayerVimeo {
  static playerLibraryRequested = false;

  static playerLibraryLoaded = false;

  static playerReadyCallbacks = [];

  constructor(src, container) {
    this.rawSrc = src;
    this.container = container;

    this.loadPlayerLibrary().then(this.loadVideo.bind(this));
  }

  // Injects and loads YTPlayer library
  loadPlayerLibrary() {
    return new Promise((resolve) => {
      const proto = Object.getPrototypeOf(this);
      const thisClass = proto.constructor;

      if (thisClass.playerLibraryLoaded) {
        return resolve();
      }

      thisClass.playerReadyCallbacks.push(resolve);

      if (!this.playerLibraryRequested) {
        this.playerLibraryRequested = true;

        // Inject library
        const tag = document.createElement("script");
        tag.src = "https://player.vimeo.com/api/player.js";
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        thisClass.checkPlayerLoaded();
      }
    });
  }

  loadVideo() {
    this.vimeoID = this.extractIdFromURL(this.rawSrc);
    if (this.vimeoID) {
      this.renderPlayer();
      this.checkPoster();
    }
  }

  extractIdFromURL(rawVideoURL = "") {
    const match = rawVideoURL.match(
      /(?:http:|https:|)\/\/(?:player.|www.)?vimeo\.com\/(?:video\/|embed\/|watch\?\S*v=|v\/)?(\d*)/i
    );

    return match && match[1] ? match[1] : null;
  }

  renderPlayer() {
    const iframe = document.createElement("iframe");

    iframe.setAttribute(
      "src",
      `https://player.vimeo.com/video/${this.vimeoID}`
    );
    iframe.setAttribute("frameborder", 0);
    iframe.setAttribute("width", this.container.offsetWidth);
    iframe.setAttribute("height", this.container.offsetWidth * (9 / 16));
    iframe.setAttribute("allow", "autoplay");

    // // Append to DOM
    this.container.insertAdjacentElement("afterbegin", iframe);

    // Load player
    this.rawPlayer = new window.Vimeo.Player(iframe);
  }

  play() {
    this.rawPlayer.play();
  }

  // Checks if a poster exists. Generate one if there isn't
  checkPoster() {
    if (!this.container.nextElementSibling.firstElementChild) {
      this.generateThumbnailURLs().then((urls) => {
        if (urls) {
          const picture = Object.assign(document.createElement("picture"), {
            className: "responsive-image",
          });

          picture.innerHTML = `
            <source media="(max-width: 767px)" srcset="${urls.mobile}">
            <source media="(max-width: 1199px)" srcset="${urls.tablet}">
            <source media="(min-width: 1200px)" srcset="${urls.desktop}">
            <img src="${urls.mobile}" alt="${urls.title}">
          `;

          this.container.nextElementSibling.innerHTML = picture.outerHTML;
        }
      });
    }
  }

  generateThumbnailURLs() {
    return fetch(`https://vimeo.com/api/v2/video/${this.vimeoID}.json`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data[0]) {
          const vimeoData = data[0];
          return {
            title: vimeoData.title,
            mobile: vimeoData.thumbnail_large.replace(/[0-9]+\.*$/, "640.jpg"),
            tablet: vimeoData.thumbnail_large.replace(/[0-9]+\.*$/, "1024.jpg"),
            desktop: vimeoData.thumbnail_large.replace(
              /[0-9]+\.*$/,
              "1280.jpg"
            ),
          };
        }
        return null;
      });
  }

  static checkPlayerLoaded() {
    if (window.Vimeo && window.Vimeo.Player) {
      // Run callbacks
      this.playerReadyCallbacks.forEach((callback) => callback());
    }

    // Retry check
    window.requestAnimationFrame(() => this.checkPlayerLoaded());
  }
}
